package org.multiplatform.kotfolio.components

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import org.multiplatform.kotfolio.models.Section
import org.multiplatform.kotfolio.models.Theme
import org.multiplatform.kotfolio.util.Constants
import org.multiplatform.kotfolio.util.observerViewPortEntered
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text
import org.multiplatform.kotfolio.rememberAppState
import kotlin.time.Duration.Companion.milliseconds

@Composable
fun sectionTitle(
    modifier: Modifier = Modifier,
    section: Section,
    alignment: Alignment.Horizontal = Alignment.Start,
) {
    val breakpoint = rememberAppState().breakpoint
    val scope = rememberCoroutineScope()

    // Use smaller offset for mobile to prevent overflow
    val initialOffset = if (breakpoint >= Breakpoint.MD) 50.px else 20.px
    var titleMargin by remember { mutableStateOf(initialOffset) }
    var subTitleMargin by remember { mutableStateOf(initialOffset) }

    observerViewPortEntered(
        sectionId = section.id,
        distanceFromTop = 700.0,
        onViewPortEntered = {
            scope.launch {
                subTitleMargin = 0.px
                if (alignment == Alignment.Start) {
                    delay(25.milliseconds)
                }
                titleMargin = 0.px
            }
        },
    )

    Column(
        modifier = modifier,
        horizontalAlignment = alignment,
    ) {
        // Pill-style Section Tag
        Box(
            modifier = Modifier
                .margin(bottom = 12.px)
                .backgroundColor(Color.rgba(245, 158, 11, 0.1f))
                .padding(leftRight = 16.px, topBottom = 4.px)
                .borderRadius(50.px)
                .border(1.px, LineStyle.Solid, Color.rgba(245, 158, 11, 0.2f)),
        ) {
            Span(
                attrs = Modifier
                    .fontFamily(Constants.FONT_FAMILY)
                    .fontSize(14.px)
                    .fontWeight(FontWeight.Bold)
                    .color(Theme.Primary.rgb)
                    .styleModifier {
                        property("letter-spacing", "2px")
                        property("text-transform", "uppercase")
                    }
                    .toAttrs(),
            ) {
                Text(section.title)
            }
        }

        // Bold Modern Subtitle
        P(
            attrs = Modifier
                .fillMaxWidth()
                .textAlign(
                    when (alignment) {
                        Alignment.CenterHorizontally -> TextAlign.Center
                        Alignment.End -> TextAlign.End
                        else -> TextAlign.Start
                    },
                )
                .margin(topBottom = 0.px)
                .fontFamily(Constants.FONT_FAMILY)
                .fontSize(if (breakpoint >= Breakpoint.MD) 54.px else 36.px)
                .fontWeight(FontWeight.Black)
                .color(Colors.White)
                .styleModifier {
                    property("letter-spacing", "-1px")
                }
                .toAttrs(),
        ) {
            Text(section.subtitle)
        }

        // Modern Underline Accent
        Box(
            modifier = Modifier
                .margin(top = 16.px)
                .height(3.px)
                .width(if (breakpoint >= Breakpoint.MD) 80.px else 60.px)
                .backgroundColor(Theme.Primary.rgb)
                .borderRadius(r = 2.px),
        )
    }
}
